<ngx-loading [show]="loading"></ngx-loading>
<div class="row first-child">
  <!-- <h3>Appointment Details</h3> -->
  <div class="" style="width: 100%" *ngIf="!is_link_expired">
    <div class="thankyoureview">
      <div>
        <img [src]="businessLogo" class="img-responsive" *ngIf="businessLogo" />
      </div>
      <span
        class="bus_name_review col-sm-12 col-12"
        style="text-transform: capitalize"
        >{{ businessName }}</span
      >
      <span class="bus_name_review col-sm-12 col-12 d-block">{{
        ownerNumber
      }}</span>
    </div>
    <p class="text-center mb-4" style="font-size: 24px">
      Review Your Appointment Details
    </p>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <form class="sec_margin_space profile_form" (ngSubmit)="confimDelete()">
        <div class="row w-100">
          <div class="w-100 delete-appointment">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="row form-group col-12">
                  <label for="name" class="busprotit_label col-md-6 col-6"
                    >Customer Name</label
                  >
                  <span
                    class="busprotit_text col-md-4 col-6"
                    style="text-transform: capitalize"
                  >
                    {{ name }}</span
                  >
                </div>
              </div>
              <div class="col-md-12 col-12">
                <div class="row form-group col-12">
                  <label for="name" class="busprotit_label col-md-6 col-6"
                    >Appointment ID</label
                  >
                  <span
                    class="busprotit_text col-md-4 col-6"
                    style="text-transform: capitalize"
                  >
                    {{ appointment_data }}</span
                  >
                </div>
              </div>
              <div class="col-md-12 col-12">
                <div class="row form-group col-12">
                  <label for="brand" class="busprotit_label col-md-6 col-6"
                    >Phone Number</label
                  >
                  <span class="busprotit_text col-md-4 col-6">
                    {{ phone_number }}</span
                  >
                </div>
              </div>
              <div class="col-md-12 col-12" *ngIf="category_name">
                <div class="row form-group col-12">
                  <label
                    for="category_name"
                    class="busprotit_label col-md-6 col-6"
                    >Category Name</label
                  >
                  <span class="busprotit_text col-md-4 col-6">{{
                    category_name
                  }}</span>
                </div>
              </div>

              <ng-container *ngIf="appointmentFlexFields.length !== 0">
                <ng-container *ngFor="let field of appointmentFlexFields">
                  <div
                    class="col-md-12 col-12"
                    *ngIf="field.name !== '' && field.content !== ''"
                  >
                    <div class="row form-group col-12">
                      <label
                        for="category_name"
                        class="busprotit_label col-md-6 col-6"
                        >{{ field.name | titlecase }}</label
                      >
                      <span class="busprotit_text col-md-4 col-6">
                        <span *ngIf="field.input_type == 'Date'">
                          {{ field.content | calendarDate: "standardView" }}
                        </span>
                        <span *ngIf="field.input_type == 'Toggle'">
                          {{ field.content == "true" ? "Yes" : "No" }}
                        </span>
                        <span
                          *ngIf="
                            field.input_type == 'Text' ||
                            field.input_type == 'Number'
                          "
                        >
                          {{ field.content }}
                        </span>
                      </span>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <div class="col-md-12 col-12">
                <div class="col-md-12 col-12">
                  <div class="row form-group col-12">
                    <label for="" class="busprotit_label col-md-6 col-6"
                      >Booking Date</label
                    >
                    <span class="busprotit_text col-md-4 col-6">{{
                      date
                    }}</span>
                  </div>
                </div>
                <div class="row form-group col-12">
                  <label for="Slot time" class="busprotit_label col-md-6 col-6"
                    >Slot time</label
                  >
                  <span class="busprotit_text col-md-4 col-6">{{
                    slot_time
                  }}</span>
                </div>
              </div>
              <div class="col-md-12 col-12">
                <div class="row form-group col-12" *ngIf="notes">
                  <label for="Notes" class="busprotit_label col-md-6 col-6"
                    >Notes</label
                  >
                  <div class="busprotit_text col-md-4 col-lg-3 col-6">
                    {{ notes }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: 35px">
              <div class="col-md-12 col-12 text-center" *ngIf="!hideDeleteBtn">
                <button class="delete-button" type="submit">
                  <!-- <img src="assets/images/save-file-option.svg">&nbsp; -->
                  Click to Cancel Appointment
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <footer style="margin: auto">
      <div class="col-md-12 col-col-sm-12 col-xs-12">
        <div class="col-xs-12 thankyoureviewfooter">
          <p>Powered by</p>
        <a href="https://www.zceppa.com" target="_blank">
          <img src="assets/images/zceppadark.svg" class="img-responsive" />
        </a>
        </div>
      </div>
    </footer>
  </div>
  <div
    class="container expiresec h-100"
    style="margin-top: 80px"
    *ngIf="is_link_expired"
  >
    <div class="row align-items-center h-100 expiresec">
      <div class="col-6 mx-auto">
        <div class="expiretext text-center">
          <h2 class="pb-3">Error!</h2>
          <img src="../../assets/images/005-sad.svg" width="80px" />
          <p class="pt-3">Oops! the page you requested no longer exists</p>
        </div>
      </div>
    </div>
    <footer>
      <div class="col-md-12 col-col-sm-12 col-xs-12">
        <div
          class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 poweredBy"
        >
          <p>Powered by</p>
        <a href="https://www.zceppa.com" target="_blank">
          <img src="assets/images/zceppadark.svg" class="img-responsive" />
        </a>
        </div>
      </div>
    </footer>
  </div>
  <ng-template #conformationModel>
    <div class="modal-body locat_pop">
      <h4 class="fw-normal">
        This action will cancel your appointment. Please confirm
      </h4>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-primary btn-sm reviwadd"
        (click)="deleteAppointment()"
      >
        Confirm
      </button>
      <button
        type="submit"
        class="btn btn-sm px-3 discard-btn"
        (click)="confimDeleteClose()"
      >
        Cancel
      </button>
    </div>
  </ng-template>
</div>
